module.exports = __webpack_public_path__ + "img/bg-section-06-mobile.f6e7136c.svg";